export default __webpack_public_path__ + "static/media/B4_23.06db2dc0.mp3";